import { AccessMode } from "@superblocksteam/shared";
import { call, select } from "redux-saga/effects";
import { getAccessMode } from "../../../../legacy/selectors/usersSelectors";
import { createSaga } from "../../../utils/saga";
import { getAnalytics } from "../client";
import slice from "../slice";

type TaskResult = Awaited<ReturnType<typeof getAnalytics>>;

function* getUserAnalyticsInternal() {
  const accessMode: ReturnType<typeof getAccessMode> =
    yield select(getAccessMode);
  if (
    accessMode === AccessMode.EXTERNAL_USER ||
    accessMode === AccessMode.VISITOR
  ) {
    return;
  }
  const result: TaskResult = yield call(getAnalytics);
  return result;
}

export const getUserAnalyticsSaga = createSaga(
  getUserAnalyticsInternal,
  "getUsersAnalyticsSaga",
  { sliceName: "user" },
);

slice.saga(getUserAnalyticsSaga, {
  start(state) {
    state.loading.recommendedDatasources = true;
  },
  success(state, { payload }) {
    state.entity.recommendedDatasources = payload?.recommendedDatasources || [];
    state.loading.recommendedDatasources = false;
  },
  error(state, { payload }) {
    state.loading.recommendedDatasources = false;
    state.error.recommendedDatasources = payload;
  },
});
